<template>
  <div class="popup" v-if="show">
    <div class="popup-box tc">
      <div v-if="subTitle == '副标题'" :class="'f36 color-333 content'+btnType">{{title}}</div>
      <div v-else style="flex-direction: column" class="content2">
        <div class="f36 color-333">{{title}}</div>
        <div class="sub-title">{{subTitle}}</div>
      </div>
      <div class="c-btns" v-if="btnType == 1">
        <GxxtButton
          class="mw120 ml15 mr15"
          :class="cancelBtnClass"
          v-if="cancelBtnText"
          @click="close"
        >{{cancelBtnText}}</GxxtButton>
        <GxxtButton
          class="ml15 mr15 mw120"
          :class="confirmBtnClass"
          v-if="confirmBtnText"
          @click="confirm"
        >{{confirmBtnText}}</GxxtButton>
      </div>
      <div class="c-btns c-btns2" v-if="btnType==2">
        <span class="c-cancel-btn" :class="cancelBtnClass" v-if="cancelBtnText" @click="close">
          {{cancelBtnText}}
          <!-- {{isMobileWx}} -->
        </span>
        <template v-if="showOpenApp">
          <template v-if="origin=='miniprogram'">
            <span class="c-confirm-btn" :class="confirmBtnClass" @click="confirm">{{confirmBtnText}}</span>
          </template>
          <template v-else>
            <span
              class="c-confirm-btn"
              :class="confirmBtnClass"
              v-if="confirmBtnText && !isMobileWx"
              @click="confirm"
            >{{confirmBtnText}}</span>
            <span
              class="c-confirm-btn wx"
              :class="confirmBtnClass"
              v-if="confirmBtnText && isMobileWx"
            >
              <!-- {{origin}} -->
              <open-app-wx
                :text="confirmBtnText"
                :style="{width: 300 * ratio + 'px',
          lineHeight: 90 * ratio + 'px',
          height: 90 * ratio + 'px',
          textAlign: 'center',
          color: '#f50',
          fontSize: 32 * ratio + 'px',}"
              ></open-app-wx>
            </span>
          </template>
        </template>
        <template v-else>
          <span
            class="c-confirm-btn"
            :class="confirmBtnClass"
            v-if="confirmBtnText"
            @click="confirm"
          >{{confirmBtnText}}</span>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      context: null,
      title: '提示',
      cancelBtnText: '取消',
      cancelBtnClass: '',
      confirmBtnText: '确定',
      confirmBtnClass: '',
      show: true,
      btnType: 1,
      showOpenApp: false,
      cancelCallback: () => {},
      confirmCallback: () => {},
      extInfo: {}, //打开微信需要的参数
      isMobileWx: false,
      ratio: 0.5,
      origin: null,
    }
  },
  methods: {
    close() {
      this.show = false
      if (typeof this.cancelCallback == 'function') {
        this.cancelCallback()
      }
    },
    confirm() {
      if (typeof this.confirmCallback == 'function') {
        this.confirmCallback()
      }
      this.show = false
    },
  },
}
</script>

<style lang="less" scoped>
.sub-title{
  font-size: 26px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #333333;
  margin-top: 30px;
}
.mw120 {
  min-width: 120px;
}
.popup {
  position: fixed;
  background: #000000ad;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  .popup-box {
    background-color: #fff;
    z-index: 1001;
    border-radius: 20px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 600px 0 0;
    min-height: 300px;

    .content1,
    .content2 {
      display: flex;
      flex: 1 0 0;
      align-items: center;
      justify-content: center;
      padding-bottom: 130px;
      &.content2 {
        padding-bottom: 90px;
        padding-left: 20px;
        padding-right: 20px;
      }
    }
    .c-btns {
      width: 100%;
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      &.c-btns2 {
        bottom: 0;
      }
      .c-cancel-btn,
      .c-confirm-btn {
        width: 50%;
        font-size: 32px;
        line-height: 90px;
        display: inline-block;
        font-weight: 500;
        border-top: 1px solid #d8d8d8;
      }
      .c-cancel-btn {
        color: #aaaaaa;
        background: #ffffff;
        border-right: 1px solid #d8d8d8;
      }
      .c-confirm-btn {
        color: #f50;
        background: #ffffff;
      }
    }
  }
}
</style>
